import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import {
  plainEnumConfig,
  toneEnumConfig,
} from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import {
  MessageChannel,
  MessageType,
  MessageTriggerType,
  MessageStatus,
  RecipientType,
  MessageTemplateType,
} from '@/features/dashboard/messages/types/MessageEnums.ts';
import {
  Clock,
  Loader,
  CheckCircle,
  RefreshCw,
  XCircle,
  Ban,
} from 'lucide-react';

export const messageChannelTableConfig: EnumTableConfig = {
  [MessageChannel.EMAIL]: plainEnumConfig('E-mail'),
  [MessageChannel.SMS]: plainEnumConfig('SMS'),
};

export const messageTypeTableConfig: EnumTableConfig = {
  [MessageType.INSTANT]: plainEnumConfig('Natychmiastowa'),
  [MessageType.PLANNED]: plainEnumConfig('Zaplanowana'),
};

export const messageTriggerTypeTableConfig: EnumTableConfig = {
  [MessageTriggerType.BOOKING_FINALIZED]: plainEnumConfig('Rezerwacja złożona'),
  [MessageTriggerType.BOOKING_CONFIRMED]: plainEnumConfig(
    'Rezerwacja potwierdzona',
  ),
  [MessageTriggerType.BOOKING_CANCELLED]: plainEnumConfig(
    'Rezerwacja anulowana',
  ),
  [MessageTriggerType.WAITLIST_ENTRY_CREATED]: plainEnumConfig(
    'Wpis na listę rezerwową',
  ),
  [MessageTriggerType.TOUR_START_REMINDER]: plainEnumConfig(
    'Przypomnienie o starcie',
  ),
  [MessageTriggerType.TOUR_END_REMINDER]: plainEnumConfig(
    'Przypomnienie o zakończeniu',
  ),
  [MessageTriggerType.TOUR_CANCELLATION]: plainEnumConfig('Odwołanie wyjazdu'),
  [MessageTriggerType.CUSTOM]: plainEnumConfig('Własna'),
};

export const messageStatusTableConfig: EnumTableConfig = {
  [MessageStatus.SCHEDULED]: {
    ...toneEnumConfig('Zaplanowana', 'info', Clock),
    tooltip: 'Zaplanowana',
    displayMode: 'icon',
  },
  [MessageStatus.PROCESSING]: {
    ...toneEnumConfig('Przetwarzanie', 'warning', Loader),
    tooltip: 'Przetwarzanie',
    displayMode: 'icon',
  },
  [MessageStatus.SENT]: {
    ...toneEnumConfig('Wysłana', 'success', CheckCircle),
    tooltip: 'Wysłana',
    displayMode: 'icon',
  },
  [MessageStatus.SCHEDULED_FOR_RETRY]: {
    ...toneEnumConfig('Ponowna próba', 'warning', RefreshCw),
    tooltip: 'Ponowna próba',
    displayMode: 'icon',
  },
  [MessageStatus.FAILED]: {
    ...toneEnumConfig('Błąd', 'error', XCircle),
    tooltip: 'Błąd',
    displayMode: 'icon',
  },
  [MessageStatus.CANCELLED]: {
    ...toneEnumConfig('Anulowana', 'caution', Ban),
    tooltip: 'Anulowana',
    displayMode: 'icon',
  },
};

export const messageTemplateTypeTableConfig: EnumTableConfig = {
  [MessageTemplateType.BOOKING_CONFIRMATION]: plainEnumConfig(
    'Potwierdzenie rezerwacji',
  ),
  [MessageTemplateType.TOUR_START_REMINDER]: plainEnumConfig(
    'Przypomnienie o starcie',
  ),
  [MessageTemplateType.TOUR_END_REMINDER]: plainEnumConfig(
    'Przypomnienie o zakończeniu',
  ),
  [MessageTemplateType.TOUR_CANCELLATION]: plainEnumConfig('Odwołanie wyjazdu'),
  [MessageTemplateType.INVITATION]: plainEnumConfig('Zaproszenie'),
  [MessageTemplateType.BOOKING_CHANGE_PENDING]: plainEnumConfig(
    'Zmiana do akceptacji',
  ),
  [MessageTemplateType.BOOKING_CHANGE_APPLIED]:
    plainEnumConfig('Zmiana wprowadzona'),
  [MessageTemplateType.BOOKING_WITHDRAWN]: plainEnumConfig(
    'Potwierdzenie rezygnacji',
  ),
  [MessageTemplateType.CONSENT_PENDING]: plainEnumConfig('Prośba o podpis'),
  [MessageTemplateType.CUSTOM]: plainEnumConfig('Własna'),
};

export const recipientTypeTableConfig: EnumTableConfig = {
  [RecipientType.CLIENT]: plainEnumConfig('Klient'),
  [RecipientType.PARTICIPANT]: plainEnumConfig('Uczestnik'),
};
